import { Box, IconButton, SwipeableDrawer, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { PropsWithChildren } from "react";

type Props = {
    icon?: JSX.Element;
    title: string;
    open: boolean;
    setOpen: (open: boolean) => void;
}

export function Slideout({ icon, title, open, setOpen, children }: PropsWithChildren<Props>) {
    return <SwipeableDrawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => { }}>
        <Box sx={{
            width: "450px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: "30px" }}>
                <Box display="flex" justifyContent="space-between" gap="15px" alignItems="center">
                    {icon}
                    <Typography variant="subtitle2">{title}</Typography>
                </Box>
                <IconButton onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </Box>
            {children}
        </Box>
    </SwipeableDrawer >
}